import { SheetDataPoint } from "../../types";
import WinnerAvatar from "../winner/WinnerAvatar";
import { WINNER_COLORS } from "../../util";

function LadderItem({
  index,
  sheetDataPoint,
}: {
  index: number;
  sheetDataPoint: SheetDataPoint;
}) {
  const percentage = `${Number(sheetDataPoint.Probability).toFixed(1)}%`;

  return (
    // --percentage is used in block styles
    // eslint-disable-next-line no-useless-computed-key
    <li style={{ ["--percentage"]: percentage } as React.CSSProperties}>
      <div>
        <WinnerAvatar
          name={sheetDataPoint.winner}
          winnerColor={WINNER_COLORS[index]}
        />
        <p>{sheetDataPoint.winner}</p>
        <p>{percentage}</p>
      </div>
      <div className="us-elections-widget__ladder-bar-wrapper">
        <span></span>
      </div>
    </li>
  );
}

export default LadderItem;
